import { forwardRef, useEffect, useRef, useState } from "react";

interface CustomDateInputProps {
  value?: string;
  onClick?: () => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const CustomDateInput = forwardRef<HTMLInputElement, CustomDateInputProps>(
  ({ value, onClick, onChange, placeholder, onKeyDown }, ref) => {
    const [inputValue, setInputValue] = useState(value || "");
    const isTyping = useRef(false);

    useEffect(() => {
      if (!isTyping.current) {
        setInputValue(value || "");
      }
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const digits = e.target.value.replace(/\D/g, "").slice(0, 8);
      let formatted = digits;
      if (digits.length > 4)
        formatted =
          digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4);
      else if (digits.length > 2)
        formatted = digits.slice(0, 2) + "/" + digits.slice(2);

      isTyping.current = true;
      setInputValue(formatted);

      if (digits.length === 8) {
        isTyping.current = false;
        e.target.value = formatted;
        onChange?.(e);
      }
    };

    const handleBlur = () => {
      isTyping.current = false;
    };

    return (
      <input
        ref={ref}
        value={inputValue}
        onClick={onClick}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        onBlur={handleBlur}
        placeholder={placeholder ?? "dd/MM/yyyy"}
        className="py-2 px-3 bg-cinza-100 rounded-lg placeholder-cinza-200 w-full cursor-pointer"
      />
    );
  },
);

CustomDateInput.displayName = "CustomDateInput";

export default CustomDateInput;
